import React, { useEffect, useState } from "react";
import * as StyledMenu from "../style/menu-style";

export const DesktopNav: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const menuItems = [
    { name: "Tjänster", to: "/#tjanster" },
    { name: "Om oss", to: "/om-oss" },
    { name: "Kontakt", to: "/om-oss#kontakt" },
  ];

  return (
    <StyledMenu.DesktopMenuContainer>
      <StyledMenu.AtLogoDesktop $isScrolled={isScrolled} />
      <StyledMenu.DesktopLinkContainer>
        {menuItems.map((item, index) => (
          <StyledMenu.AniDeskMenuLink to={item.to} key={index}>
            {item.name}
          </StyledMenu.AniDeskMenuLink>
        ))}
      </StyledMenu.DesktopLinkContainer>
    </StyledMenu.DesktopMenuContainer>
  );
};
